import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BrowserOnly from 'components/consumer/BrowserOnly';
import PDPCylindo3dViewer from 'components/consumer/PDP/PDPCylindo3dViewer';
import PDPMobileCarousel from 'components/consumer/PDP/PDPMobileCarousel';
import MobileModal from 'components/consumer/MobileModal';
import PDPDimensionsContent from 'components/consumer/PDP/PDPDimensionsContent';
import PDPDecideLaterOverlay from 'components/consumer/PDP/PDPDecideLaterOverlay';
import PDPMobileConfigurationPhotoGallery3dViewer from './PDPMobileConfigurationPhotoGallery3dViewer';
import PDPMobileDimensionsIcon from '../PDPMobileDimensionsIcon';
const PDPMobileConfigurationPhotoGalleryUI = t0 => {
  const $ = _c(28);
  const {
    isEditOrder: t1,
    enableCrops: t2,
    photos: t3,
    productName,
    cylindoFeatures,
    isCylindoAvailable,
    showDecideLaterOverlay: t4,
    isConfigFlipped: t5,
    viewGalleryImageEvent,
    shouldShowDimensionThumbnail: t6,
    upholsteryKey
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const enableCrops = t2 === undefined ? true : t2;
  let t7;
  if ($[0] !== t3) {
    t7 = t3 === undefined ? [] : t3;
    $[0] = t3;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const photos = t7;
  const showDecideLaterOverlay = t4 === undefined ? false : t4;
  const isConfigFlipped = t5 === undefined ? false : t5;
  const shouldShowDimensionThumbnail = t6 === undefined ? false : t6;
  const [isDimensionsModalOpen, setIsDimensionsModalOpen] = useState(false);
  const [selectedCarouselIndex, setSelectedCarouselIndex] = useState(0);
  let t8;
  if ($[2] !== cylindoFeatures || $[3] !== enableCrops || $[4] !== isConfigFlipped || $[5] !== isCylindoAvailable || $[6] !== isEditOrder || $[7] !== photos || $[8] !== productName || $[9] !== selectedCarouselIndex || $[10] !== showDecideLaterOverlay || $[11] !== viewGalleryImageEvent) {
    t8 = isCylindoAvailable ? <BrowserOnly><PDPMobileConfigurationPhotoGallery3dViewer hidden={!isCylindoAvailable}><PDPCylindo3dViewer cylindoFeatures={cylindoFeatures} isMobile={true} /></PDPMobileConfigurationPhotoGallery3dViewer></BrowserOnly> : <PDPMobileCarousel isEditOrder={isEditOrder} enableCrops={enableCrops} photos={photos} productName={productName} showDecideLaterOverlay={showDecideLaterOverlay} setSelectedCarouselIndex={setSelectedCarouselIndex} selectedCarouselIndex={selectedCarouselIndex} onDimensionsIconClick={showDecideLaterOverlay ? _temp : () => {
      setIsDimensionsModalOpen(true);
    }} isConfigFlipped={isConfigFlipped} onAfterSlide={idx => {
      const photo = photos[idx];
      if (photo) {
        viewGalleryImageEvent({
          imageLocation: "Configuration Gallery",
          imageFilename: photo.src?.split("/").pop() || "",
          totalImages: photos.length,
          position: idx
        });
      }
    }} />;
    $[2] = cylindoFeatures;
    $[3] = enableCrops;
    $[4] = isConfigFlipped;
    $[5] = isCylindoAvailable;
    $[6] = isEditOrder;
    $[7] = photos;
    $[8] = productName;
    $[9] = selectedCarouselIndex;
    $[10] = showDecideLaterOverlay;
    $[11] = viewGalleryImageEvent;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== showDecideLaterOverlay) {
    t9 = showDecideLaterOverlay && <PDPDecideLaterOverlay />;
    $[13] = showDecideLaterOverlay;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      setIsDimensionsModalOpen(false);
    };
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== upholsteryKey) {
    t11 = <PDPDimensionsContent upholsteryKey={upholsteryKey} />;
    $[16] = upholsteryKey;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== isDimensionsModalOpen || $[19] !== t11) {
    t12 = <MobileModal isOpen={isDimensionsModalOpen} title="Dimensions" isFullHeight={true} onClose={t10}>{t11}</MobileModal>;
    $[18] = isDimensionsModalOpen;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== shouldShowDimensionThumbnail) {
    t13 = shouldShowDimensionThumbnail && <div className="absolute right-4 top-4 z-[5] flex flex-col gap-2"><PDPMobileDimensionsIcon onClick={() => setIsDimensionsModalOpen(true)} /></div>;
    $[21] = shouldShowDimensionThumbnail;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t12 || $[24] !== t13 || $[25] !== t8 || $[26] !== t9) {
    t14 = <div className="relative min-h-[100vw]" data-xc="PDPMobileConfigurationPhotoGalleryUI">{t8}{t9}{t12}{t13}</div>;
    $[23] = t12;
    $[24] = t13;
    $[25] = t8;
    $[26] = t9;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
};
PDPMobileConfigurationPhotoGalleryUI.propTypes = {
  isEditOrder: PropTypes.bool,
  enableCrops: PropTypes.bool,
  photos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    src: PropTypes.string
  })),
  productName: PropTypes.string,
  isCylindoAvailable: PropTypes.bool,
  cylindoFeatures: PropTypes.arrayOf(PropTypes.string),
  showDecideLaterOverlay: PropTypes.bool,
  viewGalleryImageEvent: PropTypes.func,
  isConfigFlipped: PropTypes.bool,
  shouldShowDimensionThumbnail: PropTypes.bool,
  upholsteryKey: PropTypes.string
};
export default PDPMobileConfigurationPhotoGalleryUI;
function _temp() {}